import React from "react";
import { Box, Typography, Button, Container, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const NotFound = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "70vh",
          textAlign: "center",
          gap: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 120,
            height: 120,
            borderRadius: "50%",
            bgcolor: theme.palette.mode === "dark" ? "rgba(35, 148, 246, 0.1)" : "rgba(35, 148, 246, 0.05)",
            color: "#2394f6",
            mb: 2,
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 80 }} />
        </Box>

        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: "5rem", md: "8rem" },
            fontWeight: 900,
            color: "#2394f6",
            lineHeight: 1,
            fontFamily: "'DM Sans', sans-serif",
          }}
        >
          404
        </Typography>

        <Box>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              mb: 1,
              fontFamily: "'DM Sans', sans-serif",
            }}
          >
            Oops! Page Not Found
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              maxWidth: 500,
              mx: "auto",
              fontSize: "1.1rem",
            }}
          >
            The page you are looking for might have been removed, had its name changed,
            or is temporarily unavailable.
          </Typography>
        </Box>

        <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate("/")}
            sx={{
              bgcolor: "#2394f6",
              px: 4,
              py: 1.5,
              borderRadius: 2,
              fontWeight: "bold",
              textTransform: "none",
              fontSize: "1rem",
              "&:hover": {
                bgcolor: "#1a7ecb",
              },
            }}
          >
            Back to Dashboard
          </Button>
          <Button
            variant="outlined"
            size="large"
            onClick={() => navigate(-1)}
            sx={{
              px: 4,
              py: 1.5,
              borderRadius: 2,
              fontWeight: "bold",
              textTransform: "none",
              fontSize: "1rem",
              borderColor: "#2394f6",
              color: "#2394f6",
              "&:hover": {
                borderColor: "#1a7ecb",
                bgcolor: "rgba(35, 148, 246, 0.05)",
              },
            }}
          >
            Go Back
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default NotFound;
